import ReferenceData from './ReferenceData.js';

import { setCss, filter } from './functions.js';

let __ = ReferenceData.__;

// Popup con hover: https://docs.mapbox.com/mapbox-gl-js/example/popup-on-hover/
export default function MapModule(element) {
    let map;
    let directions;
    let currentMarkers = [];
    let mapContainer = element.querySelector('.map');
    let abortController;
    let defaultOrigin = element.getAttribute('kd-origin');
    let firstZone = element.getAttribute('kd-firstzone');
    let carMeta = JSON.parse(element.getAttribute('kd-carmeta'));
    let stopsLegend = null;
    let connectors = filter([carMeta.connector1, carMeta.connector2]).join(';');
    let selectCarRange = parseInt(carMeta.range, 10);

    function init() {
        createMap();
        createDirections();
        loadReferenceData();
        reinitAbortController();
    }

    function createMap() {
        map = new mapboxgl.Map({
            container: mapContainer,
            style: 'mapbox://styles/mapbox/streets-v12',
            center: [-3.7022838,40.4196311],
            zoom: 13,
            attributionControl: false,
            language: 'es',
            // antialias: true,
            preserveDrawingBuffer: true, // @link https://stackoverflow.com/q/63311120 (Sin esto no salía impreso con Chrome Headless) (NOT WORKING)
            // useWebGL2: true,
        });
        // https://bugs.chromium.org/p/chromium/issues/detail?id=809065&q=mapbox&can=2
        // https://github.com/mapbox/mapbox-gl-js/issues/7721
        // https://www.magpcss.org/ceforum/viewtopic.php?t=18371
        // https://groups.google.com/a/chromium.org/g/chromium-dev/c/8eR2GctzGuw/m/seHvu1jTAAAJ (swiftshader's support for WebGL is currently disabled on Arm)

        if (!window.IS_PDF) {
            map.addControl(new mapboxgl.NavigationControl());
            map.addControl(new mapboxgl.ScaleControl());
            map.addControl(new mapboxgl.FullscreenControl());
            map.addControl(new mapboxgl.GeolocateControl());
        }
    }

    function createDirections() {
        directions = new MapboxDirections({
            accessToken: mapboxgl.accessToken,
            unit: 'metric',
            engine: 'electric',
            profile: 'mapbox/driving',
            alternatives:false,
            language: 'es',
            interactive: false,
            controls: {
                inputs: true,
                instructions: false,
                profileSwitcher: false,
            },
        });
    }

    function loadReferenceData() {
        ReferenceData.load(window.OCM_REFERENCE_JSON_URL);
    }

    function reinitAbortController() {
        if (abortController) {
            abortController.abort();
        }
        abortController = new AbortController();
    }

    function showDirections() {
        if (!map.hasControl(directions)) {
            map.addControl(directions, 'top-left');
        }
    }

    function hideDirections() {
        if (map.hasControl(directions)) {
            map.removeControl(directions);
        }
    }

    function bindEvents() {
        directions.on('route', function(route) {
            
            let selectedRoute = route.route[0];

            toggleStopsLegend(selectedRoute.distance)

            clearMarkers();
            const data = new FormData();
            data.append('action', 'getChargersAlongRoute');
            data.append('routePolyline', JSON.stringify(polyline.decode(selectedRoute.geometry)));
            data.append('connectors', connectors);
            
            reinitAbortController();

            setLoading(true);

            fetch(window.WP_ADMIN_URL + 'admin-ajax.php', {
                method: 'POST',
                body: data,
                signal: abortController.signal,
            })
            .then(response => response.json())
            .then(function(res) {
                setLoading(false);
                clearMarkers();
                changeMarkers(res.data);
            }).catch(function(err) {
                console.error(err);
                setLoading(false);
            });
        });

        element.querySelectorAll('*[data-trip]').forEach(function(tripElm) {
            tripElm.addEventListener('click', onTripClick);
        });

        element.querySelectorAll('*[data-zone]').forEach(function(tripElm) {
            tripElm.addEventListener('click', onZoneClick);
        });

        // let firstZone = element.querySelectorAll('*[data-zone]')[0];

        // if (firstZone) {
        //     firstZone.click();
        // }

        if (firstZone) {
            showZone(firstZone);
        }

    }

    function initStopsLegend() {
        if (!stopsLegend) {
            let html = `<div class="map__stops"></div>`;
            element.insertAdjacentHTML('beforeend', html);
            stopsLegend = element.querySelector('.map__stops');
        }
    }

    function toggleStopsLegend(distance) {
        initStopsLegend();

        if (!distance) {
            setCss(stopsLegend, {display: 'none'});
            return;
        }

        let distanceInKm = distance / 1000;

        let stops = Math.floor(distanceInKm / selectCarRange);

        if (stops <= 0) {
            setCss(stopsLegend, {display: 'none'});
            return;
        }

        stopsLegend.innerHTML = window.TRANSLATIONS.MAP_STOPS_TEXTS.replace('%s', `<span class="text-medium color-green">${stops} parada${stops > 1 ? 's': ''}</span>`);

        setCss(stopsLegend, {display: 'block'});
    }

    function onTripClick(event) {
        event.preventDefault();

        abortController.abort();

        showDirections();
        
        let destination = this.getAttribute('data-trip');
        directions.setOrigin(defaultOrigin);
        directions.setDestination(destination);
    }

    function onZoneClick(event) {
        event.preventDefault();
        toggleStopsLegend(false);
        showZone(this.getAttribute('data-zone'));
    }

    function showZone(lngLat) {
        abortController.abort();

        hideDirections();

        clearMarkers();
        
        map.flyTo({
            center: lngLat.split(','),
            zoom: 13,
        });

        const data = new FormData();
        data.append('action', 'getChargersNearPoint');
        data.append('lngLat', lngLat);
        data.append('connectors', connectors);

        // setLoading(true);
        
        fetch(window.WP_ADMIN_URL + 'admin-ajax.php', {
            method: 'POST',
            body: data
        })
        .then(response => response.json())
        .then(res => {
            clearMarkers();
            changeMarkers(res.data);
            // setLoading(false);
        }).catch(err => {
            console.error(err);
            // setLoading(false);
        });
    }

    function clearMarkers() {
        currentMarkers.forEach(marker => marker.remove());
        currentMarkers = [];
    }

    function changeMarkers(data) {
        data.forEach(function(charger) {

            let markerElement = document.createElement('div');
            markerElement.classList.add('map__marker');
            markerElement.classList.add('status--' + charger.StatusTypeID);

            charger.maxLevel = ReferenceData.getMaxLevelOfPOI(charger);

            markerElement.classList.add('level--' + charger.maxLevel);

            let html = getMarkerPopupHtml(charger);

            let popup = new mapboxgl.Popup({maxWidth:300}).setHTML(html);

            // markerElement.addEventListener('click', function() {
            //     console.log('clicked charger', charger);
            // });

            let marker = new mapboxgl.Marker(markerElement)
                            .setLngLat([charger.AddressInfo.Longitude, charger.AddressInfo.Latitude])
                            .setPopup(popup)
                            .addTo(map);

            currentMarkers.push(marker);
        });
    }

    function getMarkerPopupHtml(chargerObject) {
        let rows = '';

        let middot = ` <span class="op-50">&middot;</span> `;

        chargerObject.Connections.forEach(connection => {
            let connDetails = ReferenceData.getConnectionType(connection.ConnectionTypeID);
            let currentDetails = connection.CurrentTypeID ? ReferenceData.getCurrentType(connection.CurrentTypeID)
                                                            : null;

            let quantityHtml = connection.Quantity ? `<span class="chargerimage__num">x${connection.Quantity}</span>` : '';		
                        
            let powerHtml = `${connection.PowerKW}kW`;
            let currHtml = currentDetails 	  ? `<span title="${currentDetails.Description}">${__(currentDetails.Title)}</span>` : '';
            let ampsHtml = connection.Amps 	  ? `<span>${connection.Amps}A</span>` : '';
            let voltHtml = connection.Voltage ? `<span>${connection.Voltage}V</span>` : '';

            let infoHtml = [powerHtml, currHtml, ampsHtml, voltHtml].filter(Boolean).join(middot);

            let row = `<tr>
                            <td>
                                <div class="chargerimage">
                                    <img src="${ReferenceData.getIconForConnector(connection.ConnectionTypeID)}" alt="" width="50" class="filter-white">
                                    ${quantityHtml}
                                </div>
                            </td>
                            <td>
                                <div class="mpopup__title">${__(connDetails.Title)}</div>
                                <div class="mpopup__desc">
                                    ${infoHtml}
                                </div>
                                <div class="mpopup__subtitle border-warning" style="display:none;">
                                    <span class="text-medium">400 €</span> ${middot} <span class="color-gradient">4H</span> de carga
                                </div>
                            </td>
                        </tr>`;

            rows += row;
        });

        let status = ReferenceData.getStatusType(chargerObject.StatusTypeID);

        let statusHtml = status && !ReferenceData.isOperativeStatus(chargerObject.StatusTypeID) ? `<div class="mpopup__status">${window.TRANSLATIONS.MAP_NOT_OPERATING}</div>` : '';

        let fastChargingHtml = chargerObject.maxLevel >= 3 ? `<div class="mpopup__fastcharging">${window.TRANSLATIONS.MAP_COMPLETE_CHARGE}</div>` : '';

        let addressHtml = chargerObject.AddressInfo.AddressLine1 + ', ' + (chargerObject.AddressInfo.Town || '') + ' ' + chargerObject.AddressInfo.Postcode;
                
        let html = `<div class="mpopup">
                <div class="mpopup__header">
                    <strong>${chargerObject.AddressInfo.Title}</strong><br>
                    ${addressHtml}
                </div>
                ${fastChargingHtml}
                ${statusHtml}
                <table>
                    ${rows}
                </table>
            </div>`;

        return html;
    }

    function setLoading(loading) {
        if (loading) {
            mapContainer.classList.add('is-loading');
        } else {
            mapContainer.classList.remove('is-loading');
        }
    }

    init();
    bindEvents();
}